import { useEffect, useState } from 'react';

/// Breakpoint `lg` do Tailwind. O player de replay decide EM JS onde ancorar os
/// painéis flutuantes (#557): a lista e o card de detalhe são posicionados por
/// medição (top/bottom em px), e posição calculada não tem como cair num
/// `lg:` de CSS. Mesma régua dos dois lados pra que o layout não fique meio
/// mobile, meio desktop numa faixa de larguras.
const LG_QUERY = '(min-width: 1024px)';

export function useIsWideViewport(query = LG_QUERY): boolean {
  const [wide, setWide] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  );

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mql = window.matchMedia(query);
    const onChange = () => setWide(mql.matches);
    onChange();
    // `addEventListener` no MediaQueryList é o caminho moderno; Safari < 14
    // (iPad velho de organizador) só tem `addListener`. O fallback custa duas
    // linhas e evita a tela quebrar em silêncio ao girar o aparelho.
    if (mql.addEventListener) {
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    }
    mql.addListener(onChange);
    return () => mql.removeListener(onChange);
  }, [query]);

  return wide;
}
